import { enableProdMode, provideZoneChangeDetection, Type } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl(): string {
	return document.getElementsByTagName('base')[0].href;
}

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
	enableProdMode();
}
let moduleToBootstrap: Type<any>;
moduleToBootstrap = AppModule;
platformBrowserDynamic(providers)
	.bootstrapModule(moduleToBootstrap, { applicationProviders: [provideZoneChangeDetection()], })
	.catch((err) => console.log(err));
